export const timeFormatTommss = (time) => {
	const minute = Math.floor(parseInt(time) / 60)
		.toString()
		.padStart(2, '0');
	const second = parseInt(time % 60)
		.toString()
		.padStart(2, '0');
	return `${minute}:${second}`;
};
